<ion-item>

  @if (showCheckbox) {
    <yu-checkbox
      style="width: auto"
      slot="start"
      [(value)]="item[ngModelCheckbox]"
    ></yu-checkbox>
  }

  <ion-thumbnail slot="start">
    <img [src]="item.foto || 'assets/img/empty-img/no_image.png'" alt=""/>
  </ion-thumbnail>

  <ion-label class="ion-text-wrap">

    <div class="title">{{ item.nombre }}</div>

    <div class="description">
      {{ item.cantidad - item.cantidad_confirmada }} x {{ item.formato_ver }}
    </div>

    <div class="description info">#{{ item.pedido_ref }} | {{ item.pedido_fecha | date:'dd/MM/yyyy' }}</div>

  </ion-label>

  @if (data.should_see_price_by_provider_context && permissionsManager.checkPermission('precios', 'ver')) {

    <ion-note slot="end">

      <p class="cost">
        <span [ngClass]="{'discount line': item.descuento}">
          {{ ((item.cantidad - item.cantidad_confirmada) * (item.precio || 0)) | currency: 'EUR': 'symbol': '1.2-2': 'es' }}
        </span>

        @if (item.descuento) {
          <span>
            {{ ((item.cantidad - item.cantidad_confirmada) * item.precio_final) | currency: 'EUR': 'symbol': '1.2-2': 'es' }}
          </span>
        }
      </p>

      @if (item.descuento) {
        <p class="discount">{{ item.descuento }}% Dto.</p>
      }

    </ion-note>

  }

</ion-item>
